<template>
  <span>
    <topnav class="w-100" style="position: fixed; z-index: 999; top: 0;"></topnav>
    <router-view></router-view>
  </span>
</template>
<script>
import { mapState } from "vuex";
import topnav from "./../layouts/nav_bar.vue";
export default {
  name: "",
  components: {
    topnav,
  },
  created() {},
  data() {
    return {};
  },
  computed: {
    ...mapState,
  },
  methods: {},
};
</script>
